// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qN2E","col":"styles_col__2UHn-"};